import { apiConfig } from 'core-lib/config/config';
import { deleteMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import toast from 'react-hot-toast';
import { CartItem } from '../../types/cart';
import { serializeCart } from './getCart';

const deleteItemFromCart = async (item: CartItem) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/carts/mine/items/custom/${item.cartItemId}`;

  const { response, error }: any = await deleteMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
    enableErrorHandling: true,
  });

  if (response?.data) {
    return serializeCart(response.data);
  }
  return null;
};

export default deleteItemFromCart;
